import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import LabelsList from './LabelsList';

const LabelsListPage = () => {
    const { t } = useTranslation(['labelsList']);
    const company = useCompany(true);
    const { permissions: accountPermissions } = useAccount();

    const addLabel = useGoTo('/admin/labels/add');
    const extra = company &&
        company.availableModules.hasLabelsModules &&
        hasPermissions(accountPermissions, [permissionKind.createLabel]) && (
            <Button icon={<PlusOutlined />} onClick={addLabel} type="primary">
                {t('labelsList:actions.addLabel')}
            </Button>
        );

    return (
        <ConsolePageWithHeader extra={extra} title={t('labelsList:title')}>
            {!company || company.availableModules.hasLabelsModules ? (
                <LabelsList />
            ) : (
                <NoItemResult subTitle={t('labelsList:moduleNotAvailable')} />
            )}
        </ConsolePageWithHeader>
    );
};

export default LabelsListPage;
